import { render } from "./FormSearch.vue?vue&type=template&id=2100fcb8"
import script from "./FormSearch.vue?vue&type=script&lang=js"
export * from "./FormSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__